import Logo from "@/components/icons/Logo";

type AuthLayoutProps = {
  children: React.ReactNode;
};

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="h-screen w-screen flex justify-center items-center bg-brand-neutral-900">
      <div className="rounded-xl shadow-lg p-4 flex flex-col items-center gap-6 w-full h-full overflow-scroll">
        <Logo />
        {children}
      </div>
    </div>
  );
}
